import { commonActions } from 'common/context/CommonSlice';
import { useAppDispatch } from 'common/context/hooks';
import { useFetch } from 'common/hooks/useFetchSwr';
import { AdminTablePaths } from 'common/model/AdminTablePaths';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export const CategoryManager = () => {
  const dispatch = useAppDispatch();
  const { branchId } = useParams<{ branchId: string }>();
  const fetchUrl = `${AdminTablePaths.CATEGORY}?branch=${branchId}`;
  const { data } = useFetch<Category[]>(fetchUrl);

  useEffect(() => {
    if (data) dispatch(commonActions.setCategories(data));
  }, [data, dispatch]);

  return null;
};
